import {
    ArrowRightOutlined,
    ArrowUpOutlined,
    BulbOutlined,
    CalendarOutlined,
    CaretRightOutlined,
    CloseOutlined,
    FacebookOutlined,
    FileOutlined,
    InstagramOutlined,
    LinkedinOutlined,
    LinkOutlined,
    PlusOutlined,
    SearchOutlined,
    StarOutlined,
    ThunderboltOutlined,
    ToolOutlined,
} from "@ant-design/icons";
import {
    Button,
    Dropdown,
    Form,
    Input,
    Segmented,
    Spin,
    Empty,
    theme,
} from "antd";
import log from "cslog";
import { useAtom } from "jotai";
import { Fragment, useEffect, useRef, useState } from "react";
import { useSingleItem } from "../_actions/app/items";
import PhotoButton from "../qforms/standard_elements/PhotoButton";
import RelationFieldStanard from "../qforms/standard_elements/RelationFieldStandard";
import {
    useGenerateTemplateSuggestions,
    useRandomTemplates,
    useRandomTemplatesNew,
    useSpotlightSearch,
    useBotEndpontGet,
    useBotEndpoint,
} from "../_actions/bot";
import {
    getFileURL,
    getImageFileURL,
    getPublicImageURL,
} from "../_helpers/image";
import { useCreateItemMutation, useItemsFine } from "../actions/app/items";
import {
    useGenerateConceptPresetDataWithAI,
    useGeneratePresetDataWithAI,
} from "../ai_img_gen/post_processing";
import IdeaCanvasBox from "../content_calender_new/IdeaCanvasBox";
import ImagePicker from "../editor/imagepicker/ImagePicker";
import { PresetInputForm } from "../qmade/creator/TemplateAIInput";
import { spotlightResultsAtom } from "../spotlight/atoms";
import { useDebounce } from "../utils/input";
import styles from "./styles/QurealSpotlight.module.css";
import TokenInButton from "../finance/TokenInButton";
import { COST_PROCESS_IDEA } from "../constants";
import { startCase } from "lodash";
import classNames from "classnames";
import LoadingBox from "../common/LoadingBox";
import OneDay from "../ai_home/OneDay";
import dayjs from "dayjs";
import FileMasterNew from "../file_master_new/FileMasterNew";
import AIToolBox from "../ai_toolbox/AIToolBox";
import ProductSelector from "../qbuilt_settings/brands/org/ProductSelector";

const { TextArea } = Input;

const FIELDS =
    "id,type,title,preview.id,preview.filename_disk,is_themeable,tags.qdb_tag_id.*,inputs,used_schemas.qdb_creation_schema_id.id,used_schemas.qdb_creation_schema_id.name,used_schemas.qdb_creation_schema_id.user_prompt_question";

// statue = idle, loading, suggestion, preset_input, result
// result type= result_preset, result_calendar, result_featival, result_trend
// data = result
function useSpotlight() {
    const [search_query, setSearchQuery] = useState("");
    // const debounced_query = useDebounce(search_query, 500);
    const debounced_query = useDebounce(search_query, 400);
    const [isLoading, setLoading] = useState(false);
    const [result, setResult] = useAtom(spotlightResultsAtom);
    const [enable_suggestion, setEnableSuggestion] = useState(true);
    const [enable_chat, setEnableChat] = useState(false);

    const {
        isSuccess: successSuggestion,
        isLoading: loadingSuggestion,
        data: dataSuggestionResponse,
    } = useBotEndpontGet(
        "/spotlight/search",
        {
            q: debounced_query,
            limit: 5,
        },
        enable_suggestion && !!debounced_query
    );

    const dataSuggestion =
        dataSuggestionResponse?.results?.map?.((res) => ({
            id: res.id,
            label: res.title,
            platforms: res.platforms,
            value: {
                type: res.type,
                data: res.data,
            },
        })) || [];

    useEffect(() => {
        if (successSuggestion || loadingSuggestion) {
            if (dataSuggestion?.length === 1) {
            } else {
                // setResult({
                //     show: false,
                //     type: null, // preset, calendar, trend
                //     data: {},
                // });
            }
        }
    }, [successSuggestion, dataSuggestion, loadingSuggestion]);

    useEffect(() => {
        if (debounced_query?.length === 0) {
            setResult({
                show: false,
                type: null, // preset, calendar, trend
                data: {},
            });
        }
    }, [debounced_query]);

    useEffect(() => {
        if (search_query?.length > 5) {
            if (isLink(search_query)) {
                setEnableSuggestion(false);
                setResult({
                    show: true,
                    type: "gen_from_source",
                    data: {
                        url: search_query,
                    },
                });
            } else {
                setEnableSuggestion(true);
            }
            if (search_query?.length > 30) {
                setEnableSuggestion(false);
                setResult({
                    show: false,
                    type: null,
                    data: {},
                });
            }
        } else {
            setEnableSuggestion(true);
        }
    }, [search_query]);

    log.d(result, "result in spotlight");

    return {
        search_query,
        setSearchQuery,
        debounced_query,
        isLoading: isLoading || loadingSuggestion,
        suggestions: dataSuggestion,
        result,
        setResult,
        enable_chat,
        setEnableChat,
        enable_suggestion,
    };
}

function QurealLightCore({
    me,
    open,
    setOpen,
    isMobile,
    selected_item,
    setSelectedItem,
    open_preview,
    setOpenPreview,
    prefill = null,
    is_spot = false,
    inputRef,
}) {
    const { token } = theme.useToken();
    const enable_generate = false;
    const [activePrompt, setActivePrompt] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const [images, setImages] = useState([]);
    // const inputRef = useRef(null);
    const {
        search_query,
        setSearchQuery,
        debounced_query,
        isLoading,
        suggestions,
        result,
        setResult,
        enable_chat,
        setEnableChat,
        enable_suggestion,
    } = useSpotlight();

    useEffect(() => {
        // no-op: single-line layout, no auto-resize needed
    }, [search_query]);

    useEffect(() => {
        setFocusedIndex(-1);
    }, [debounced_query]);

    log.d(images, "images in QLC");

    const dropdownItems = [
        {
            key: "select",
            label: (
                <ImagePicker
                    trigger={<div>Select Image</div>}
                    many={false}
                    onSelect={(selectedImages) => {
                        const formatted = selectedImages.map((img) => ({
                            ...img,
                            type: "image",
                            value: img.id,
                        }));
                        setImages((old) => [
                            ...old.filter((i) => i.type !== "product"),
                            ...formatted,
                        ]);
                    }}
                />
            ),
            icon: <i className="fas fa-image"></i>,
        },
        {
            key: "upload",
            label: (
                <div
                    onClick={() => {
                        alert("Use 'select image' for now");
                    }}
                >
                    Upload an Image
                </div>
            ),
            icon: <i className="fas fa-upload"></i>,
        },
        {
            key: "product",
            label: (
                <ProductSelector
                    trigger={<div>Select Product</div>}
                    onSelect={(product) => {
                        setImages([
                            {
                                ...product,
                                type: "product",
                                value: product.id,
                            },
                        ]);
                    }}
                />
            ),
            icon: <i className="fas fa-box" />,
        },
    ];

    const handleInputChange = (e) => {
        const val = e.target.value;
        setSearchQuery(val);
        setResult({ show: false });
        if (!val) {
            setActivePrompt(null);
            setIsGenerating(false);
        }
    };

    const handleInputKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setFocusedIndex((prev) =>
                Math.min(prev + 1, suggestions.length - 1)
            );
            return;
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            setFocusedIndex((prev) => Math.max(prev - 1, -1));
            return;
        }
        if (e.key === "Enter") {
            e.preventDefault();
            if (focusedIndex >= 0 && suggestions[focusedIndex]) {
                setResult({
                    show: true,
                    ...suggestions[focusedIndex].value,
                });
                setFocusedIndex(-1);
            } else if (search_query && !isGenerating) {
                setResult({ show: false });
                setActivePrompt(search_query);
            }
        }
    };

    const handleSend = () => {
        if (search_query && !isGenerating) {
            setResult({ show: false });
            setActivePrompt(search_query);
        }
    };

    // ── Mobile: full-screen overlay, input pinned to bottom ───────
    if (isMobile) {
        return (
            <Fragment>
                <div
                    className={classNames({
                        [styles.work_area]: true,
                        [styles.work_area_spot]: is_spot,
                    })}
                    onClick={(e) => e.stopPropagation()}
                >
                    {is_spot && (
                        <div
                            className={styles.mobile_close_btn}
                            onClick={() => setOpen(false)}
                        >
                            <CloseOutlined />
                        </div>
                    )}

                    {/* Scrollable content area — suggestions last = closest to input */}
                    <div className={styles.mobile_scroll_area}>
                        {isLoading && (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    padding: "20px",
                                }}
                            >
                                <Spin size="small" />
                            </div>
                        )}

                        <SpotlightResults
                            results={result}
                            setResults={setResult}
                            me={me}
                            attachments={images}
                        />

                        {activePrompt && (
                            <div className={styles.results_wrapper}>
                                <PromptToGraphics
                                    user_prompt={activePrompt}
                                    me={me}
                                    onClose={() => setActivePrompt(null)}
                                    onLoadingChange={setIsGenerating}
                                    attachments={images}
                                />
                            </div>
                        )}

                        {!result?.show && !activePrompt && (
                            <SpotlightSuggestions
                                is_stale={
                                    debounced_query !== search_query ||
                                    isLoading
                                }
                                suggestions={suggestions}
                                focusedIndex={focusedIndex}
                                onSuggestionClick={(item) => {
                                    setResult({
                                        show: true,
                                        ...item?.value,
                                    });
                                }}
                            />
                        )}
                    </div>

                    <div className={styles.mobile_input_bar}>
                        {images.length > 0 && (
                            <div className={styles.mobile_image_preview_area}>
                                <SpotlightImagePreview
                                    images={images}
                                    setImages={setImages}
                                />
                            </div>
                        )}

                        <div className={styles.mobile_input_row}>
                            <Dropdown
                                trigger={["click"]}
                                menu={{ items: dropdownItems }}
                            >
                                <div
                                    style={{
                                        width: "34px",
                                        flexShrink: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        color: "#666",
                                    }}
                                >
                                    <PlusOutlined
                                        style={{ fontSize: "1rem" }}
                                    />
                                </div>
                            </Dropdown>

                            <textarea
                                placeholder="What would you like to create today?"
                                ref={inputRef}
                                className={styles.search_box_input}
                                value={search_query}
                                onChange={handleInputChange}
                                onKeyDown={handleInputKeyDown}
                                rows={1}
                            />

                            <Button
                                type="primary"
                                className={styles.send_button}
                                onClick={handleSend}
                                loading={isGenerating}
                                icon={<ArrowUpOutlined />}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    // ── Desktop ───────────────────────────────────────────────────
    return (
        <Fragment>
            <div
                // className={styles.work_area}
                className={classNames({
                    [styles.work_area]: true,
                    [styles.work_area_spot]: is_spot,
                })}
                onClick={(e) => e.stopPropagation()}
            >
                {images.length > 0 && (
                    <div style={{ padding: "10px 14px 0" }}>
                        <SpotlightImagePreview
                            images={images}
                            setImages={setImages}
                        />
                    </div>
                )}

                <div className={styles.search_box_wrapper}>
                    <Dropdown
                        trigger={["click"]}
                        menu={{ items: dropdownItems }}
                    >
                        <div
                            style={{
                                width: "34px",
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                color: "#666",
                            }}
                        >
                            <PlusOutlined style={{ fontSize: "1rem" }} />
                        </div>
                    </Dropdown>

                    <textarea
                        placeholder="What would you like to create today?"
                        ref={inputRef}
                        className={styles.search_box_input}
                        value={search_query}
                        onChange={handleInputChange}
                        onKeyDown={handleInputKeyDown}
                        rows={1}
                    />

                    <Button
                        type="primary"
                        className={styles.send_button}
                        onClick={handleSend}
                        loading={isGenerating}
                        icon={<ArrowUpOutlined />}
                    />
                </div>

                {isLoading && (
                    <div
                        style={{
                            height: "80px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderTop: `1px solid ${token.colorBorderSecondary}`,
                        }}
                    >
                        <Spin size="small" />
                    </div>
                )}

                {!result?.show && !activePrompt && (
                    <SpotlightSuggestions
                        is_stale={debounced_query !== search_query || isLoading}
                        suggestions={suggestions}
                        focusedIndex={focusedIndex}
                        onSuggestionClick={(item) => {
                            setResult({
                                show: true,
                                ...item?.value,
                            });
                        }}
                    />
                )}

                <SpotlightResults
                    results={result}
                    setResults={setResult}
                    me={me}
                    attachments={images}
                />

                {activePrompt && (
                    <div className={styles.results_wrapper}>
                        <PromptToGraphics
                            user_prompt={activePrompt}
                            me={me}
                            onClose={() => setActivePrompt(null)}
                            onLoadingChange={setIsGenerating}
                            attachments={images}
                        />
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default QurealLightCore;

const SUGGESTION_TYPE_ICONS = {
    PRESET: <ThunderboltOutlined />,
    FESTIVAL: <StarOutlined />,
    CALENDAR: <CalendarOutlined />,
    FILE: <FileOutlined />,
    TOOL: <ToolOutlined />,
};

function SuggestionTypeIcon({ type }) {
    return (
        SUGGESTION_TYPE_ICONS[type?.toUpperCase()] ?? <ThunderboltOutlined />
    );
}

function SpotlightSuggestions({
    suggestions,
    onSuggestionClick,
    is_stale,
    focusedIndex = -1,
}) {
    // const { isSuccess, isLoading, data } = useItemsFine(
    //     "qdb_spotlight_suggestions",
    //     `limit=5&filter[text][_contains]=${search_query}`,
    //     !!search_query
    // );

    // full blown search if uper wala fails
    // const [all_suggestions, setAllSuggestions] = useState([]);
    // const mutationSearch = useSpotlightSearch((result) => {
    //     log.d(result, "result in spotlight search");
    //     if (result?.success && result?.data?.length > 0) {
    //         setAllSuggestions(result?.data);
    //     }
    // });

    // useEffect(() => {
    //     if (isSuccess) {
    //         setAllSuggestions(data);
    //     }
    // }, [isSuccess, data]);

    // useEffect(() => {
    //     if (isSuccess && data?.length === 1) {
    //         onSuggestionClick(data[0]);
    //     } else if (isSuccess && data?.length === 0) {
    //         // activate fuzzy search
    //         mutationSearch.mutate({
    //             search_query: search_query,
    //         });
    //     }
    // }, [isSuccess, data]);

    useEffect(() => {
        if (!is_stale && suggestions?.length === 1) {
            onSuggestionClick(suggestions[0]);
        }
    }, [suggestions, is_stale]);

    return (
        <div className={styles.suggestions_wrapper}>
            {suggestions?.map((item, idx) => {
                const isFocused = idx === focusedIndex;
                return (
                    <div
                        className={classNames(styles.suggestion_item, {
                            [styles.suggestion_item_focused]: isFocused,
                        })}
                        key={item.id}
                        onClick={() => {
                            onSuggestionClick(item);
                        }}
                    >
                        <span className={styles.suggestion_icon}>
                            <SuggestionTypeIcon type={item.value?.type} />
                        </span>
                        <span className={styles.suggestion_label}>
                            {item.label}
                        </span>
                        <div className={styles.suggestion_right}>
                            <PlatformRender platforms={item.platforms} />
                            {(isFocused || idx === 0) && (
                                <span className={styles.suggestion_enter}>
                                    ↵
                                </span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

const PLATFORM_MAPPING = {
    facebook: (
        <FacebookOutlined style={{ fontSize: "1.6em", color: "#3b5998" }} />
    ),
    instagram: (
        <InstagramOutlined style={{ fontSize: "1.6em", color: "#c13584" }} />
    ),
    linkedin: (
        <LinkedinOutlined style={{ fontSize: "1.6em", color: "#0077b5" }} />
    ),
};

function PlatformRender({ platforms }) {
    return (
        <div className={styles.platform_wrapper}>
            {platforms?.map((item) => {
                return <span>{PLATFORM_MAPPING[item]}</span>;
            })}
        </div>
    );
}

// type = preset, calendar, festival, trend, concept_preset, gen_from_source
function SpotlightResults({ results, setResults, me, attachments = [] }) {
    if (!results?.show || !results?.type) {
        return null;
    }

    const resType = results?.type?.toUpperCase();

    return (
        <div className={styles.results_wrapper}>
            {resType === "CALENDAR" && (
                <SPCalendar data={results?.data} me={me} />
            )}
            {resType === "TREND" && <SPTrending />}
            {resType === "PRESET" && (
                <SPPreset
                    data={results?.data}
                    me={me}
                    attachments={attachments}
                />
            )}
            {resType === "FESTIVAL" && (
                <SPFestival data={results?.data} me={me} />
            )}
            {resType === "CONCEPT_PRESET" && (
                <SPConceptPreset data={results?.data} me={me} />
            )}
            {resType === "GEN_FROM_SOURCE" && (
                <SPGenFromSource
                    // data={results?.data}
                    me={me}
                />
            )}
            {resType === "FILE" && <SPFile data={results?.data} me={me} />}
            {resType === "TOOL" && <SPTool data={results?.data} me={me} />}
        </div>
    );
}

function PromptToGraphics({
    user_prompt,
    me,
    onClose,
    onLoadingChange,
    attachments = [],
}) {
    const { token } = theme.useToken();
    const [phase, setPhase] = useState("loading"); // loading | needs_input | complete | error
    const [needsInputData, setNeedsInputData] = useState(null);
    const [design, setDesign] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const mutation = useBotEndpoint("/gen/prompt_to_graphics", (result) => {
        const designData = result?.data?.design || result?.data?.canvas?.design;
        if (result?.status === "complete" && designData) {
            setDesign(designData);
            setPhase("complete");
        } else if (result?.status === "needs_input") {
            setNeedsInputData(result.data);
            setPhase("needs_input");
        } else if (result?.status === "error" || result?.success === false) {
            setErrorMessage(
                result?.message || "Something went wrong. Please try again."
            );
            setPhase("error");
        }
    });

    useEffect(() => {
        mutation.mutate({ user_prompt, attachments: attachments });
    }, []);

    useEffect(() => {
        onLoadingChange?.(mutation.isLoading);
    }, [mutation.isLoading]);

    if (phase === "loading" || mutation.isLoading) {
        return (
            <SPResultWrapper>
                <div
                    style={{
                        height: "110px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                    }}
                >
                    <Spin />
                    <span
                        style={{
                            fontSize: "0.78rem",
                            color: token.colorTextTertiary,
                            letterSpacing: "0.02em",
                        }}
                    >
                        Generating your design…
                    </span>
                </div>
            </SPResultWrapper>
        );
    }

    if (phase === "error" || mutation.isError) {
        const msg = errorMessage || "Something went wrong. Please try again.";
        return (
            <SPResultWrapper>
                <div style={{ padding: "12px 0", color: "#ff4d4f" }}>{msg}</div>
            </SPResultWrapper>
        );
    }

    if (phase === "needs_input" && needsInputData) {
        return (
            <UserInputsCollector
                data={needsInputData}
                userPrompt={user_prompt}
                me={me}
                onComplete={(resultDesign) => {
                    setDesign(resultDesign);
                    setPhase("complete");
                }}
            />
        );
    }

    if (phase === "complete" && design) {
        if (design?.primary_tag) {
            return <SPFestival data={{ tag: design.primary_tag }} me={me} />;
        }

        return (
            <IdeaCanvasBox
                key={design.template_id}
                open={true}
                setOpen={(open) => {
                    if (!open) onClose();
                }}
                data={{
                    status: "generated",
                    generated_data: {
                        canvas: { design },
                    },
                }}
                me={me}
            />
        );
    }

    return null;
}

function UserInputsCollector({ data, userPrompt, me, onComplete }) {
    // data = { preset_name, filled_inputs, unfilled_inputs }
    const [form] = Form.useForm();
    const [errorMessage, setErrorMessage] = useState(null);
    const [img_values, setImgValues] = useState({});

    const mutation = useBotEndpoint("/gen/prompt_to_graphics", (result) => {
        if (result?.status === "complete" && result?.data?.design) {
            onComplete(result.data.design);
        } else if (result?.status === "error" || result?.success === false) {
            setErrorMessage(
                result?.message || "Something went wrong. Please try again."
            );
        }
    });

    return (
        <SPResultWrapper title={data?.preset_name}>
            <Form
                form={form}
                layout="vertical"
                onFinish={(values) => {
                    mutation.mutate({
                        user_prompt: userPrompt,
                        preset_name: data?.preset_name,
                        user_inputs: {
                            ...data?.filled_inputs,
                            ...values,
                            ...img_values,
                        },
                    });
                }}
                style={{ marginTop: "10px" }}
            >
                {data?.unfilled_inputs?.map((input) => {
                    const isDbType = input.type?.startsWith("db_");
                    const tableName = isDbType ? input.type.substring(3) : null;
                    return (
                        <Form.Item
                            key={input.key}
                            name={input.key}
                            label={input.label || startCase(input.key)}
                            rules={[{ type: "string", max: 200 }]}
                        >
                            {(!input.type || input.type === "text") && (
                                <Input placeholder="Enter message" />
                            )}
                            {input.type === "textarea" && (
                                <TextArea
                                    rows={4}
                                    placeholder={input.label || "Enter message"}
                                />
                            )}
                            {input.type === "image" && (
                                <PhotoButton
                                    field={{
                                        collection: "qqq",
                                        field: input.key,
                                    }}
                                    width="150px"
                                    height="150px"
                                    objectFit="contain"
                                    show_placeholder={true}
                                    background="white"
                                    enable_remove_bg={false}
                                    onChangeFull={(photo_obj) => {
                                        setImgValues({
                                            ...img_values,
                                            [input.key]: photo_obj,
                                        });
                                    }}
                                />
                            )}
                        </Form.Item>
                    );
                })}
                {(errorMessage || mutation.isError) && (
                    <div style={{ color: "#ff4d4f", marginBottom: "12px" }}>
                        {errorMessage ||
                            "Something went wrong. Please try again."}
                    </div>
                )}
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={mutation.isLoading}
                    >
                        Generate
                    </Button>
                </Form.Item>
            </Form>
        </SPResultWrapper>
    );
}

function SPCalendar({ data, me }) {
    let date = dayjs();
    if (data?.dt === "tomorrow") {
        date = date.add(1, "day");
    } else if (data?.dt === "yesterday") {
        date = date.subtract(1, "day");
    }

    return (
        <SPResultWrapper title={startCase(data?.dt)}>
            <OneDay
                me={me}
                date={date.toISOString()}
                showHeader={true}
                padding_x={0}
                border={false}
            />
        </SPResultWrapper>
    );
}

function SPTrending() {
    return (
        <SPResultWrapper title="Trending Ideas">
            <h2>Trending ideas</h2>
        </SPResultWrapper>
    );
}

function SPConceptPreset({ data, me }) {
    const [canvas, setCanvas] = useState({});
    const { updateInputs, isLoading } =
        useGenerateConceptPresetDataWithAI(setCanvas);

    const {
        isSuccess: successPreset,
        isLoading: loadingPreset,
        data: dataPreset,
    } = useSingleItem(
        "qdb_concept_schema",
        `/${data?.preset_id}`,
        !!data?.preset_id
    );

    return (
        <SPResultWrapper title={data?.preset}>
            {successPreset && (
                <PresetInputForm
                    schema={dataPreset}
                    isLoading={loadingPreset}
                    onSubmit={(values) => {
                        log.d(values, "submit values in SPPreset");
                        updateInputs({
                            // block_id: data?.preset,
                            preset_id: data?.preset_id,
                            user_inputs: values,
                            // extra: {},
                            // post_context: "",
                            // template_id: null,
                        });
                    }}
                    onChange={() => {}}
                />
            )}
            {canvas?.success && (
                <IdeaCanvasBox
                    key={data?.preset_id}
                    open={true}
                    setOpen={(new_open) => {
                        if (!new_open) {
                            setCanvas(null);
                        }
                    }}
                    data={{
                        status: "generated",
                        generated_data: {
                            canvas: canvas?.data,
                            // canvas: {deisgn: {}}
                        },
                    }}
                    me={me}
                />
            )}
        </SPResultWrapper>
    );
}

function SPPreset({ data, me, attachments = [] }) {
    const {
        isSuccess: successPreset,
        isLoading: loadingPreset,
        data: dataPreset,
    } = useSingleItem(
        "qdb_creation_schema",
        // `?filter[block_id][_eq]=${data?.preset}`,
        `/${data?.preset_id}?fields=*,similar.*,similar.related_qdb_creation_schema_id.*`,
        !!data?.preset
    );
    const [prefill, setPrefill] = useState({});
    const [mapped_prefill, setMappedPrefill] = useState({});
    const { updateInputs, isLoading } = useGeneratePresetDataWithAI(setPrefill);
    const [selected_card, setSelectedCard] = useState(null);
    const [history_id, setHistoryId] = useState(null);

    // NEW: selected preset from segmented (defaults to the opened preset)
    const [selectedPreset, setSelectedPreset] = useState(null);

    useEffect(() => {
        setPrefill({});
    }, [data?.preset]);

    useEffect(() => {
        log.d(prefill, "prefill in SPPreset");
        const out = {};
        Object.keys(prefill).forEach((key) => {
            out[key] = {
                success: true,
                data: prefill[key],
                post_processing: {},
            };
        });
        setMappedPrefill(out);
        setHistoryId(prefill?.history_id);
    }, [prefill]);

    // set default selected preset once base preset is loaded
    useEffect(() => {
        if (dataPreset?.id)
            setSelectedPreset({
                id: dataPreset.id,
                name: "Default",
                block_id: dataPreset.block_id,
            });
    }, [dataPreset?.id]);

    // clear any prefill when switching between similar presets
    useEffect(() => {
        setPrefill({});
        setMappedPrefill({});
        setHistoryId(null);
    }, [selectedPreset?.id]);

    const preset_data = dataPreset;
    // load the schema of the selected preset for input form
    const {
        isSuccess: successSchema,
        isLoading: loadingSchema,
        data: selectedSchema,
    } = useSingleItem(
        "qdb_creation_schema",
        `/${selectedPreset?.id}?fields=*.*`,
        !!selectedPreset?.id
    );

    // choose correct id for templates (origin_preset if present)
    const selectedFinalPresetId =
        selectedSchema?.origin_preset?.id || selectedPreset?.id;

    const {
        isSuccess: successTemplates,
        isLoading: loadingTemplates,
        data: dataTemplates,
    } = useRandomTemplatesNew(
        selectedFinalPresetId,
        null,
        "id,title,is_themeable,preview",
        2,
        !!selectedFinalPresetId && successSchema
    );

    const allPresetOptions = (() => {
        const base = preset_data
            ? [
                  {
                      id: preset_data.id,
                      name: "Default",
                      block_id: preset_data.block_id,
                  },
              ]
            : [];
        const similars =
            preset_data?.similar
                ?.map((s) => {
                    const rel = s?.related_qdb_creation_schema_id;
                    return rel
                        ? {
                              id: rel.id,
                              // name: rel.name,
                              name: s.name,
                              block_id: rel.block_id,
                          }
                        : null;
                })
                .filter(Boolean) || [];
        // de-dup by id
        const seen = new Set();
        return [...base, ...similars].filter((o) => {
            if (seen.has(o.id)) return false;
            seen.add(o.id);
            return true;
        });
    })();
    const segmentedOptions = allPresetOptions.map((o) => ({
        label: o.name,
        value: o.id,
    }));

    return (
        <SPResultWrapper
            // title="Preset"
            title={
                selectedSchema?.display_name ||
                selectedSchema?.name ||
                dataPreset?.display_name ||
                dataPreset?.name
            }
            // loading={loadingTemplates || loadingPreset}
            loading={loadingPreset}
        >
            {preset_data && Object.keys(mapped_prefill).length === 0 && (
                <div>
                    {segmentedOptions.length > 1 && (
                        <Segmented
                            options={segmentedOptions}
                            value={selectedPreset?.id}
                            onChange={(val) => {
                                const meta = allPresetOptions.find(
                                    (o) => o.id === val
                                );
                                setSelectedPreset(meta);
                            }}
                            style={{ marginBottom: 12 }}
                        />
                    )}

                    {loadingSchema && <LoadingBox height="100px" />}

                    {successSchema && (
                        <PresetInputForm
                            schema={selectedSchema}
                            isLoading={isLoading || loadingSchema}
                            onSubmit={(values) => {
                                log.d(values, "submit values in SPPreset");
                                updateInputs({
                                    block_id: selectedPreset.block_id,
                                    preset_id: selectedPreset.id,
                                    user_inputs: values,
                                    extra: {},
                                    post_context: "",
                                    template_id: null,
                                });
                            }}
                            onChange={() => {}}
                            attachments={attachments}
                        />
                    )}
                </div>
            )}
            {successTemplates &&
                (Object.keys(mapped_prefill).length > 0 ||
                    selectedSchema?.inputs?.length === 0) && (
                    <div className={styles.grid_wrapper}>
                        {dataTemplates?.map((item) => {
                            return (
                                <img
                                    src={getPublicImageURL(item?.preview)}
                                    alt="preview"
                                    className={styles.preview}
                                    onClick={() => {
                                        setSelectedCard(item);
                                    }}
                                />
                            );
                        })}
                    </div>
                )}

            {selected_card && (
                <IdeaCanvasBox
                    key={selected_card?.id}
                    open={true}
                    setOpen={(new_open) => {
                        if (!new_open) {
                            setSelectedCard(null);
                        }
                    }}
                    data={{
                        status: "generated",
                        generated_data: {
                            canvas: {
                                design: {
                                    preset_id: selectedPreset.id,
                                    template_id: selected_card?.id,
                                    prefill: mapped_prefill,
                                },
                                history_id: history_id,
                            },
                        },
                    }}
                    me={me}
                />
            )}
        </SPResultWrapper>
    );
}

function SPFile({ data, me }) {
    return (
        <SPResultWrapper title="File handler">
            <FileMasterNew data={{ data: data }} />
        </SPResultWrapper>
    );
}

function SPTool({ data, me }) {
    return (
        <SPResultWrapper title="AI Tool">
            {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
            <AIToolBox tool_id={data?.tool_id} />
        </SPResultWrapper>
    );
}

function SPFestival({ data, me }) {
    const {
        isSuccess: successTemplates,
        isLoading: loadingTemplates,
        data: dataTemplates,
    } = useItemsFine(
        "qdb_creation_template",
        // `fields=${FIELDS}&limit=4&filter[tags][qdb_tag_id][name][_contains]=${data?.tag}`,
        `fields=${FIELDS}&limit=4&filter[primary_tags][qdb_tag_id][name][_eq]=${data?.tag}`,
        !!data.tag
    );
    const [selected_card, setSelectedCard] = useState(null);

    return (
        <SPResultWrapper
            title={startCase(data?.tag)}
            loading={loadingTemplates}
        >
            {successTemplates && dataTemplates?.length === 0 && (
                <Empty description="No design available" />
            )}
            {successTemplates && dataTemplates?.length > 0 && (
                <div className={styles.grid_wrapper}>
                    {dataTemplates?.map((item) => {
                        return (
                            <img
                                src={getImageFileURL(
                                    item?.preview?.filename_disk
                                )}
                                alt="preview"
                                className={styles.preview}
                                onClick={() => {
                                    // setOpenPreview(true);
                                    // setSelectedItem({
                                    //     type: "template",
                                    //     data: item,
                                    // });
                                    setSelectedCard(item);
                                }}
                            />
                        );
                    })}
                </div>
            )}

            {selected_card && (
                <IdeaCanvasBox
                    key={selected_card?.id}
                    open={true}
                    setOpen={(new_open) => {
                        if (!new_open) {
                            setSelectedCard(null);
                        }
                    }}
                    data={{
                        status: "generated",
                        generated_data: {
                            canvas: {
                                design: {
                                    preset_id:
                                        "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98",
                                    primary_tag: data?.tag,
                                    template_id: selected_card?.id,
                                    // prefill: prefill,
                                    prefill: {},
                                },
                            },
                        },
                    }}
                    me={me}
                />
            )}
        </SPResultWrapper>
    );
}

function SPGenFromSource({ data, me }) {
    return (
        <SPResultWrapper
            // title="Analyse link"
            loading={false}
        >
            <div
                style={{
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Button type="primary" icon={<LinkOutlined />}>
                    Analyse Link
                </Button>
            </div>
        </SPResultWrapper>
    );
}

function SPResultWrapper({ title, content, loading, children }) {
    return (
        <div style={{ padding: "18px 0 20px" }}>
            {title && <p className={styles.heading}>{title}</p>}
            {loading && (
                <div className={styles.blank_wrapper}>
                    <Spin />
                </div>
            )}
            {!loading && children}
        </div>
    );
}

function ProductCardPreview({ product, onRemove }) {
    const { token } = theme.useToken();
    return (
        <div
            style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 28px 6px 6px",
                border: `1px solid ${token.colorBorder}`,
                borderRadius: "8px",
                background: token.colorFillAlter,
                maxWidth: "220px",
            }}
        >
            <img
                src={getPublicImageURL(product.main_image)}
                alt={product.name}
                style={{
                    width: "44px",
                    height: "44px",
                    objectFit: "contain",
                    borderRadius: "4px",
                    border: `1px solid ${token.colorBorderSecondary}`,
                    flexShrink: 0,
                    background: token.colorBgContainer,
                }}
            />
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                    minWidth: 0,
                }}
            >
                <span
                    style={{
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {product.name}
                </span>
                {product.price != null && (
                    <span
                        style={{
                            fontSize: "0.72rem",
                            color: token.colorSuccess,
                        }}
                    >
                        ₹{product.price}
                    </span>
                )}
            </div>
            <CloseOutlined
                style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-4px",
                    backgroundColor: token.colorText,
                    color: token.colorBgContainer,
                    borderRadius: "50%",
                    fontSize: "10px",
                    padding: "2px",
                    cursor: "pointer",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                }}
                onClick={onRemove}
            />
        </div>
    );
}

function SpotlightImagePreview({ images, setImages }) {
    const { token } = theme.useToken();
    return (
        <div
            style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                padding: "6px 0 4px",
            }}
        >
            {images.map((image, index) => {
                if (image.type === "product") {
                    return (
                        <ProductCardPreview
                            key={index}
                            product={image}
                            onRemove={() =>
                                setImages((old) =>
                                    old.filter((_, i) => i !== index)
                                )
                            }
                        />
                    );
                }

                const src =
                    image.url ||
                    image.src?.medium ||
                    image.previewURL ||
                    image.src;
                return (
                    <div
                        key={index}
                        style={{
                            position: "relative",
                            width: "80px",
                            height: "80px",
                        }}
                    >
                        <img
                            src={src}
                            alt="preview"
                            style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                outline: `1px solid ${token.colorBorderSecondary}`,
                            }}
                        />
                        <CloseOutlined
                            style={{
                                position: "absolute",
                                top: "-4px",
                                right: "-4px",
                                backgroundColor: token.colorText,
                                color: token.colorBgContainer,
                                borderRadius: "50%",
                                fontSize: "10px",
                                padding: "2px",
                                cursor: "pointer",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                            }}
                            onClick={() =>
                                setImages((old) =>
                                    old.filter((_, i) => i !== index)
                                )
                            }
                        />
                    </div>
                );
            })}
        </div>
    );
}

function isLink(text) {
    return text?.startsWith("http://") || text?.startsWith("https://");
}
